<template>
  <section
    :class="{
      'wistia-video-component': true,
    }"
  >
    <div :class="{ 'container mx-auto': true }">
      <div
        :class="{
          'video-container relative mx-auto aspect-video w-full': true,
        }"
        :style="
          embedType === 'inlineFixed' || embedType === 'popover' ?
            { maxWidth: `${props.width}${props.widthType}`, height: 'auto', margin: '0 auto' }
          : {}
        "
      >
        <client-only>
          <div
            v-if="video && embedType === 'inlineAuto'"
            :class="{
              ['wistia_embed wistia_async_' + video[0].hashed_id]: true,
              'h-full w-full': true,
            }"
          ></div>

          <div
            v-else-if="video && embedType === 'popover'"
            :style="computedStyle"
            :class="{
              ['wistia_embed wistia_async_' + video[0].hashed_id]: true,
              'popover=true popoverContent=thumbnail': true,
              'popoverAnimateThumbnail=true wistia_embed_initialized': true,
            }"
          ></div>
          <div
            v-else-if="video && embedType === 'inlineFixed'"
            :class="{
              ['wistia_embed wistia_async_' + video[0].hashed_id]: true,
              'absolute left-0 top-0 h-full w-full': true,
            }"
          ></div>
        </client-only>
      </div>
    </div>
  </section>
</template>
<script lang="ts" setup>
import { useWindowSize } from '@vueuse/core';
import type { WistiaVideo } from '~/sanity/types';
const props = defineProps<WistiaVideo>();
useHead({
  script: [
    { hid: 'wistia-script', src: 'https://fast.wistia.com/assets/external/E-v1.js', async: true },
  ],
});

const { width } = useWindowSize();
const isDesktop = computed(() => {
  return width.value > 1024;
});

const computedStyle = computed(() => {
  const widthValue = `${props.width}${props.widthType}`;
  let style;
  if (isDesktop.value) {
    style = { width: `${widthValue}`, height: '100%', margin: '0 auto', maxWidth: '100%' };
  } else {
    style = { width: '100%', height: '100%' };
  }
  return style;
});
</script>
